import { useState, useEffect } from "react";
import { api } from "./api";

let _configCache = null;

export function useConfig() {
  const [config, setConfig] = useState(_configCache);
  useEffect(() => {
    if (_configCache) return;
    api.get("/config").then(({ data }) => {
      _configCache = data;
      setConfig(data);
    }).catch(() => {});
  }, []);
  return config;
}

// The UI language defines everything: number format, phone mask and the market (country/currency).
export const LANG_LOCALE = { pt: "pt-BR", "pt-PT": "pt-PT", en: "en-US", es: "es-ES", fr: "fr-FR", it: "it-IT" };
export const LANG_MARKET = {
  pt: { country: "BR", currency: "BRL" }, "pt-PT": { country: "PT", currency: "EUR" }, en: { country: "US", currency: "USD" },
  es: { country: "ES", currency: "EUR" }, fr: { country: "FR", currency: "EUR" }, it: { country: "IT", currency: "EUR" },
};
let _moneyLocale = LANG_LOCALE[localStorage.getItem("mc_lang")] || "pt-BR";
export function setMoneyLocale(lang) { _moneyLocale = LANG_LOCALE[lang] || "pt-BR"; }
export function moneyLocale() { return _moneyLocale; }
// 1000 -> "1.000,00" (BRL) | "1,000.00" (USD) | "1.000,00" (EUR)
export function nf(value) {
  return Number(value || 0).toLocaleString(_moneyLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Display rule (all markets): "<symbol> <value>" with ONE space; decimals only when the value has cents.
// BR "R$ 2.500" / "R$ 39,90" · US "US$ 800" / "US$ 15.97" · EU "€ 700" / "€ 14,97"
export function normSymbol(symbol) { return symbol === "$" ? "US$" : symbol || ""; }
export function nfd(value) {
  const n = Number(value || 0);
  const whole = Math.abs(n - Math.round(n)) < 0.005;
  return n.toLocaleString(_moneyLocale, { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
}
export function formatMoney(symbol, value) {
  if (value == null) return "—";
  return `${normSymbol(symbol)} ${nfd(value)}`;
}

export function symbolForCurrency(config, currency) {
  if (!config) return currency === "BRL" ? "R$" : currency === "USD" ? "US$" : "€";
  const c = config.countries.find((x) => x.currency === currency);
  return normSymbol(c ? c.symbol : "€");
}

export function localeForCurrency(currency) {
  return currency === "BRL" ? "pt-BR" : currency === "USD" ? "en-US" : "de-DE";
}

export function fmtAmount(currency, value) {
  if (value == null || value === "") return "";
  return nf(value);
}
